import React, { useState } from "react";

// Icons
import LinkedinIcon from "assets/icons/social-media/LinkedinIcon";

// Images
import Maria_R_Nindita_Radyati_img from "../../assets/consultings/partners/Maria_R_Nindita_Radyati.jpeg";
import Amalia_Yunita_img from "../../assets/consultings/partners/Amalia_Yunita.webp";
import Silverius_Oscar_Unggul_img from "../../assets/consultings/partners/Silverius_Oscar_Unggul.png";

// Components
import ThinkPartnerDetail from "./ThinkPartnerDetail";

const ThinkPartner = () => {
  const partners = [
    {
      image: Maria_R_Nindita_Radyati_img,
      name: "Maria R Nindita Radyati, PhD",
      position: (
        <div>
          Pakar{" "}
          <b>
            bidang ESG, CSR, Community Development, Social Enterprise dan
            Sustainability
          </b>
        </div>
      ),
      linked_in_url: "https://www.linkedin.com/in/mariaradyati",
      profile:
        "Dr. Maria R. Nindita Radyati is someone who is deeply driven in her mission to educate, and she has taken on this mission for more than 25 years. You can find her serving as an expert or speaker in a multitude of seminars, trainings, and workshops both in and out of Indonesia. This is due to her expertise which include corporate social responsibility, sustainability strategic design, sustainability reporting, social entrepreneurship, ESG mapping, and many more. She first started teaching in the Economics Faculty of Trisakti University, which is also where she founded MM-CSR, a master’s degree program that specializes in corporate social responsibility and it is the first master's degree program in Asia Pacific that focuses on Sustainability. Aside from being a founder in ISA, Dr. Maria R. Nindita Radyati is also the head of the ESG Task Force of KADIN (Indonesian Chamber of Commerce and Industry) and she is also a member of APCO Worldwide’s International Advisory Committee and the Vice President Learning of Indonesia Global Compact Network (IGCN).",
    },
    {
      image:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/f858b4486dd223d59b007aa5006c3db8a239917d3600aef32a802e03ca58155c4563f8d57b69ad1cb01e88cd79fda5d970568696e923275c156a932e91f253bd73051569f7a3e332cf9b6a5e6fc0c858b9394ceb74b9f360c7b3cae061bb0d962c01d18ee0609f88c50c551e8528fd54e6d9ef900d2596002567/rez-file-1739419811304.png",
      name: "Widyamurti Paramita",
      position: (
        <div>
          Pakar <b>bidang Sustainability dan ESG Reporting</b>
        </div>
      ),
      profile:
        "Widyamurti is a sustainability professional with a strong academic background and over ten years of experience in the field. She has contributed to the development of more than 25 Sustainability Reports, serving as editor and copywriter. Since 2022, she has been the Vice Director of the Institute for Sustainability and Agility, leading various initiatives in sustainability. Her previous roles include Sustainability Manager at PT Industri Jamu dan Farmasi Sido Muncul Tbk (2020–2022) and a key position at PT Salim Ivomas Pratama Tbk, Indofood’s agribusiness subsidiary, where she helped strengthen sustainability implementation. In addition to her industry expertise, Widyamurti has shared her knowledge as a Visiting Lecturer at the Faculty of Economics and Business, Universitas Atma Jaya and Universitas Trisakti. Through both her professional and academic roles, she has remained actively involved in supporting sustainability efforts in Indonesia.",
    },
    {
      image: Amalia_Yunita_img,
      name: "Dr. Amalia Yunita",
      position: (
        <div>
          Pakar <b>bidang Sustainable Tourism</b>
        </div>
      ),
      linked_in_url: "https://www.linkedin.com/in/amalia-yunita-6432185a",
      profile:
        "Amalia Yunita is eager to both obtain knowledge and share knowledge to people. She has a degree in Civil Engineering from Trisakti University, and obtained a Magister Management of Sustainability with a Cum Laude from MM-Sustainability Trisakti. She has more than 2 decades worth of experience in the Adventure & Travel Industry in Indonesia, and has been part of many expeditions to various mountains and other nature hotspots around the world. She acts as a founder and director of many Adventure Travel companies in Indonesia, examples of them being; Arus Liar (Lintas Jeram Nusantara) since 1995, Bravo Outdoor Supplies & Services since 2011, Bramanta Wana Parahita (Bravo Adventure) since 2013, and much more. She is part of the Council of Experts of CECT Trisakti University, and also a lecturer in MM-Sustainability Trisakti. Amalia Yunita is active in various Global Rescue Network missions and has also partaken in many rafting competitions.",
    },
    {
      image: Silverius_Oscar_Unggul_img,
      name: "Silverius Oscar Unggul",
      position: (
        <div>
          Pakar <b>bidang Kehutanan</b>
        </div>
      ),
      linked_in_url: "https://www.linkedin.com/in/sunggul",
      profile: `Silverius Oscar Unggul, also known as "Bang Onte", is a prominent Indonesian social and environmental activist, best known as the founder of Telapak, an organization that promotes community-based forest and marine resource management. He has played a key role in transforming illegal logging practices into sustainable forestry enterprises that improve rural livelihoods. In addition to serving as President of Telapak, he is the Vice Chairman of the Indonesian Chamber of Commerce (KADIN) for Environment and Forestry, and since 2025, has served as Senior Advisor to the Minister of Forestry. Silverius also established several community media platforms, such as Radio Swara Alam and Kendari TV, and founded SOBI, a social enterprise promoting sustainable timber trade. His impactful work has earned him numerous international recognitions, including the Ashoka Fellowship, Skoll Award, and Young Global Leader by the World Economic Forum.`,
    },
  ];

  const [selectedPartnerToView, setSelectedPartnerToView] = useState(null);

  return (
    <div className="space-y-8 app-main-container">
      <div className="pt-3 pb-4 space-y-6 md:pt-6 md:pb-8">
        <p className="text-xl font-bold text-center sm:text-2xl app-animation-translate-start">
          Think partner anda saat ini
        </p>
      </div>
      <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
        {partners.map((item, i) => (
          <div
            key={i}
            className="flex flex-col gap-2 transition-all duration-300 cursor-pointer app-animation-scale-start"
          >
            <img
              src={item.image}
              alt={item.name}
              className="object-cover w-full border rounded-lg aspect-square"
            />
            <div className="flex flex-col justify-between">
              <div>
                <p className="text-base font-bold md:text-lg xl:text-xl">
                  {item.name}
                </p>
                <p className="pt-1 text-sm md:text-sm xl:text-sm">
                  {item.position}
                </p>
              </div>
              {item.linked_in_url && item.linked_in_url !== "" && (
                <div>
                  <a
                    href={item.linked_in_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LinkedinIcon className="w-5 h-5 mt-2 fill-black md:h-6 xl:h-8 md:w-6 xl:w-8" />
                  </a>
                </div>
              )}
              <p
                className="pt-5 text-sm md:text-sm xl:text-sm hover:underline hover:decoration-solid hover:decoration-2 hover:underline-offset-[6px] hover:opacity-90 hover:font-bold"
                onClick={() => setSelectedPartnerToView(item)}
              >
                Click to view profile
              </p>
            </div>
          </div>
        ))}
      </div>
      {selectedPartnerToView ? (
        <ThinkPartnerDetail
          partner={selectedPartnerToView}
          onClose={() => setSelectedPartnerToView(null)}
        />
      ) : null}
    </div>
  );
};

export default ThinkPartner;
